import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home.vue'
import info from '@/pages/info.vue'
import login from '@/pages/login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: home,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/info',
    name: 'info',
    component: info,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      keepAlive: false
    }
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js